import httpInstances from '@/api/axiosInstance';
import { enqueueIndexCall } from '@/api/indexQueuer';
import type { SymbolKey } from '@/entities/symbol/types';
import { toQueryParams } from '@/utils/toQueryParams';

export type IndexMetadata = {
  Title: string;
  Currency: string;
  Units: string;
  Alias?: string;
};

export type OtherGroupIndexValues = {
  Index?: string;
  Mid?: string;
  PeriodAbs: string;
} & Record<string, string | undefined>;

export type OtherGroupIndexEntry = {
  transactionTime: string;
  metadata?: IndexMetadata;
  values: OtherGroupIndexValues;
};

export const fetchOtherGroupIndex = async (
  key: SymbolKey,
  group: string,
  options?: { from?: string | null; to?: string | null }
): Promise<OtherGroupIndexEntry[]> => {
  const params = toQueryParams({
    code: key.Code,
    timeref: key.TimeRef,
    period: key.Period,
    periodtype: key.PeriodType,
    from: options?.from ?? '2v',
    to: options?.to || undefined,
    metadata: 'true',
    group
  });
  return enqueueIndexCall(() =>
    httpInstances.axiosDataInstance
      .get<OtherGroupIndexEntry[]>(`/index${params}`, { headers: { Accept: 'application/json' } })
      .then(({ data }) => data)
  );
};
